import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, paymentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getAllPlans: ApiMethod<void, Server.PlanOutput[], any> = async (
  _,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Plans_Client(undefined, paymentClient);
    const response = await client.plans_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getMyPlans: ApiMethod<
  void,
  Server.CustomerPlanOutput[],
  any
> = async (_, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Plans_Client(undefined, paymentClient);

    const response = await client.plans_customer_get_V1();

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
